import Repository from '../axios'
const pagination = 150
export default {
  getCustomersList(filterQuery = null){
    return Repository.get(`/admin/customer-list?is_paginate=0&${filterQuery}`)
  },
  getStaffList(filterQuery = null, is_paginate = 0){
    return Repository.get(`/admin/staff-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getApprovedSupplierList(filterQuery = null, is_paginate = 0){
    return Repository.get(`/admin/supplier-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getApprovedSundrySupplierList(filterQuery = null){
    return Repository.get(`/admin/supplier/sundry-supplier-list?paginate=${pagination}&${filterQuery}`)
  },
  getFormulationList(filterQuery= null, is_paginate = 0){
    return Repository.get(`/admin/formulation-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getApprovedCourierList(filterQuery= null){
    return Repository.get(`/admin/supplier/courier-list?paginate=${pagination}&${filterQuery}`)
  },
  getOtherSupplierList(filterQuery= null){
    return Repository.get(`/admin/supplier/other-supplier-list?is_paginate=0&${filterQuery}`)
  },
  getManufacturingSites(supplier_id,filterQuery= null){
    return Repository.get(`/admin/supplier/saq/site-list?supplier_id=${supplier_id}&${filterQuery}`)
  },
  getProjectBriefDropDownList(filterQuery= null, is_paginate = 0, ){
    return Repository.get(`/admin/customer/project-brief-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getProductionCodesList(filterQuery= null){
    return Repository.get(`/admin/formulations/production-code-list?${filterQuery}`)
  },
  getRawMaterialCategoryList(filterQuery= null){
    return Repository.get(`/admin/supplier/raw-material-category-list?${filterQuery}`)
  },
  getRawMaterialCarrierList(filterQuery= null){
    return Repository.get(`/admin/supplier/raw-material-carrier-list?${filterQuery}`)
  },
  getProductOrderList(customer_id, is_paginate = 0, filterQuery= null) {
    return Repository.get(`/admin/customer/product-order-list?customer_id=${customer_id}&is_paginate=${is_paginate}&${filterQuery}`)
  },
  getCustomerUsersDropdownList(customer_id) {
    return Repository.get(`/admin/customer/user-list?customer_id=${customer_id}&is_paginate=0`)
  },
  getSupplierRoleList() {
    return Repository.get(`/admin/supplier/roles?paginate=100`)
  },
  getCustomerLeadList(filterQuery= null, is_paginate = 0, ) {
    return Repository.get(`/admin/marketing/lead-list?is_exclude_customers=1&is_paginate=${is_paginate}&${filterQuery}`)
  },
  getCustomerCrmSubjectList(is_paginate = 0) {
    return Repository.get(`/admin/system_setting/customer/communication-subjects?is_paginate=${is_paginate}`)
  },
  getAllProductOrderList(is_paginate = 0, filterQuery= null) {
    return Repository.get(`/admin/customer/product-order-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getAllSampleOrderList(is_paginate = 0 ,filterQuery= null) {
    return Repository.get(`/admin/customer/sample_order_list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getAllSalesQuotesList(is_paginate = 0, filterQuery= null) {
    return Repository.get(`admin/customer/sales/sale-quote-list?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getStaffAccountHandlers(is_paginate = 0, filterQuery= null) {
    return Repository.get(`/admin/staff/account-handlers?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getCustomerUserTypes(is_paginate = 0, filterQuery= null) {
    return Repository.get(`/admin/system_setting/user-types?is_paginate=${is_paginate}&${filterQuery}`)
  },
  getCarrierList(is_paginate = 0) {
    return Repository.get(`/admin/supplier/raw-material-carrier-list?is_paginate=${is_paginate}`)
  },
  getStaffLeaveReviewers(is_paginate = 0, filterQuery= null) {
    return Repository.get(`/admin/staff/leave-reviewers?is_paginate=${is_paginate}&${filterQuery}`)
  },
}
